import { apiFetch } from "./api";

export interface JobNotificationDto {
  jobNotificationId: number;
  jobId: number;
  jobReferenceNo: string;
  kind: string;
  title: string;
  body: string | null;
  readAtUtc: string | null;
  createdAtUtc: string;
}

export const jobNotificationKeys = {
  unread: ["jobs", "notifications", "unread"] as const,
};

export const jobNotifications = {
  unread: () => apiFetch<JobNotificationDto[]>(`/api/jobs/notifications?unread=true`),
  markRead: (id: number) => apiFetch<void>(`/api/jobs/notifications/${id}/mark-read`, { method: "POST" }),
};
